import { render, staticRenderFns } from "./list-task.vue?vue&type=template&id=08ae2e7c"
import script from "./list-task.vue?vue&type=script&lang=js"
export * from "./list-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports